import types from "./types";

// Product Detail Fetch
export const getTeamMatesReq = (payload) => ({
  type: types.GET_TEAMMATES_REQ,
  payload,
});
export const getTeamMatesRes = (payload) => ({
  type: types.GET_TEAMMATES_RESPONSE,
  payload,
});
export const getTeamMatesResClear = () => ({
  type: types.GET_TEAMMATES_RESPONSE_CLEAR,
});

export const getReaReportReq = (payload) => ({
  type: types.GET_REA_LIST_REPORT_REQ,
  payload,
});
export const getReaReportRes = (payload) => ({
  type: types.GET_REA_LIST_REPORT_RESPONSE,
  payload,
});
export const getReaReportResClear = () => ({
  type: types.GET_REA_LIST_REPORT_RESPONSE_CLEAR,
});

export const getCourseReportReq = (payload) => ({
  type: types.GET_COURSE_LIST_REPORT_REQ,
  payload,
});
export const getCourseReportRes = (payload) => ({
  type: types.GET_COURSE_LIST_REPORT_RESPONSE,
  payload,
});
export const getCourseReportResClear = () => ({
  type: types.GET_COURSE_LIST_REPORT_RESPONSE_CLEAR,
});

export const getManagerReportReq = (payload) => ({
  type: types.GET_MANAGER_LIST_REPORT_REQ,
  payload,
});
export const getManagerReportRes = (payload) => ({
  type: types.GET_MANAGER_LIST_REPORT_RESPONSE,
  payload,
});
export const getManagerReportResClear = () => ({
  type: types.GET_MANAGER_LIST_REPORT_RESPONSE_CLEAR,
});

export const getProviderReportReq = (payload) => ({
  type: types.GET_PROVIDER_LIST_REPORT_REQ,
  payload,
});
export const getProviderReportRes = (payload) => ({
  type: types.GET_PROVIDER_LIST_REPORT_RESPONSE,
  payload,
});
export const getProviderReportResClear = () => ({
  type: types.GET_PROVIDER_LIST_REPORT_RESPONSE_CLEAR,
});

export const setCurrentView = (payload) => ({
  type: types.CURRENT_VIEW,
  payload,
});

export const setJoyRideReq = (payload) => ({
  type: types.JOY_RIDE,
  payload,
});

export const setShowDropDown = (payload) => ({
  type: types.SHOW_DROPDOWN,
  payload,
});

export const setShowMoreMenuReq = (payload) => ({
  type: types.SHOW_MORE_MENU,
  payload,
});


export const setCongratClassName = (payload) => ({
  type: types.GET_CLASS,
  payload,
});

export const doAssignTeamMates = (payload) => ({
  type: types.ASSIGN_TEAMMATES_REQ,
  payload,
});
export const doAssignTeamMatesRes = (payload) => ({
  type: types.ASSIGN_TEAMMATES_RESPONSE,
  payload,
});
export const doAssignTeamMatesResClear = () => ({
  type: types.ASSIGN_TEAMMATES_RESPONSE_CLEAR,
});

export const getOfficeListReq = (payload) => ({
  type: types.SEARCH_OFFICE_LIST_REQ,
  payload,
});
export const getOfficeListRes = (payload) => ({
  type: types.SEARCH_OFFICE_LIST_RESPONSE,
  payload,
});
export const getOfficeListResClear = () => ({
  type: types.SEARCH_OFFICE_LIST_RESPONSE_CLEAR,
});

export const getCompletedCourseList = (payload) => ({
  type: types.COMPLETED_COURSE_LIST_REQ,
  payload,
});
export const getCompletedCourseListRes = (payload) => ({
  type: types.COMPLETED_COURSE_LIST_RESPONSE,
  payload,
});
export const getCompletedCourseListResClear = () => ({
  type: types.COMPLETED_COURSE_LIST_RESPONSE_CLEAR,
});

// Get office list by user

export const getUsersByOfficeList = (payload) => ({
  type: types.GET_USERS_BY_OFFICE_LIST,
  payload,
});
export const getUsersByOfficeListResponse = (payload) => ({
  type: types.GET_USERS_BY_OFFICE_LIST_RESPONSE,
  payload,
});

export const getUsersByOfficeListClear = (payload) => ({
  type: types.GET_USERS_BY_OFFICE_LIST_CLEAR,
  payload,
});

export const getTeamListReq = (payload) => ({
  type: types.GET_TEAMS_LIST_REQ,
  payload,
});
export const getTeamListResponse = (payload) => ({
  type: types.GET_TEAMS_LIST_RES,
  payload,
});

export const getTeamListResponseClear = (payload) => ({
  type: types.GET_TEAMS_LIST_RES_CLEAR,
  payload,
});

export const assignToTeamsReq = (payload) => ({
  type: types.ASSIGN_TO_TEAMS_REQ,
  payload,
});
export const assignToTeamsResponse = (payload) => ({
  type: types.ASSIGN_TO_TEAMS_RES,
  payload,
});

export const assignToTeamsResponseClear = (payload) => ({
  type: types.ASSIGN_TO_TEAMS_RES_CLEAR,
  payload,
});

export const getAssignUserReq = (payload) => ({
  type: types.GET_ASSIGN_USERS,
  payload,
});
export const getAssignUserResponse = (payload) => ({
  type: types.GET_ASSIGN_USERS_RES,
  payload,
});

export const getAssignUserResponseClear = (payload) => ({
  type: types.GET_ASSIGN_USERS_RES_CLEAR,
  payload,
});
//Filter LP Report
export const getFilterLp = (payload) => ({
  type: types.CHOOSE_LP_REPORT_FILTER,
  payload,
});
export const getFilterLpResponse = (payload) => ({
  type: types.CHOOSE_LP_REPORT_FILTER_RES,
  payload,
});
export const getFilterLpClear = (payload) => ({
  type: types.CHOOSE_LP_REPORT_FILTER_CLEAR,
  payload,
});

//Filter LP Report
export const getAssignUsersList = (payload) => ({
  type: types.GET_ASSIGN_USER_LIST,
  payload,
});
export const getAssignUsersListResponse = (payload) => ({
  type: types.GET_ASSIGN_USER_LIST_RES,
  payload,
});
export const getAssignUsersListResClear = (payload) => ({
  type: types.GET_ASSIGN_USER_LIST_CLEAR,
  payload,
});

export const changeDueDateAssignUser = (payload) => ({
  type: types.CHANGE_DUE_DATE_ASSIGN_USER_LIST,
  payload,
});
export const changeDueDateAssignUserResponse = (payload) => ({
  type: types.CHANGE_DUE_DATE_ASSIGN_USER_LIST_RES,
  payload,
});
export const changeDueDateAssignUserResClear = (payload) => ({
  type: types.CHANGE_DUE_DATE_ASSIGN_USER_LIST_CLEAR,
  payload,
});

export const getCategoryByEntityID = (payload) => ({
  type: types.GET_CATEGORY_BY_ENTITY_ID, payload
})
export const getCategoryByEntityIDResponse = (payload) => ({
  type: types.GET_CATEGORY_BY_ENTITY_ID_RES, payload
})
export const getCategoryByEntityIDClear = () => ({
  type: types.GET_CATEGORY_BY_ENTITY_ID_CLEAR
})

export const getAvailableLPByEntityID = (payload) => ({
  type: types.AVAILABLE_LP_BY_ENTITY_ID, payload
})
export const getAvailableLPByEntityIDResponse = (payload) => ({
  type: types.AVAILABLE_LP_BY_ENTITY_ID_RES, payload
})
export const getAvailableLPByEntityIDClear = () => ({
  type: types.AVAILABLE_LP_BY_ENTITY_ID_CLEAR
})

export const getBrokerageFitlerList = (payload) => ({
  type: types.GET_BROKERAGE_FILTER_LIST_REQ, payload
})
export const getBrokerageFilterListResponse = (payload) => ({
  type: types.GET_BROKERAGE_FILTER_LIST_REQ_RESPONSE, payload
})
export const getBrokerageFilterListClear = () => ({
  type: types.GET_BROKERAGE_FILTER_LIST_REQ_CLEAR
})


export const getSurveyListReportReq = (payload) => ({
  type: types.GET_SURVEY_LIST_REPORT_REQ,
  payload,
});
export const getSurveyListReportRes = (payload) => ({
  type: types.GET_SURVEY_LIST_REPORT_REQ_RESPONSE,
  payload,
});
export const getSurveyListReportResClear = () => ({
  type: types.GET_SURVEY_LIST_REPORT_REQ_RESPONSE_CLEAR,
});

//Filter LP Report
export const getFilterSurveyLp = (payload) => ({
  type: types.CHOOSE_LP_SURVEY_REPORT_FILTER,
  payload,
});
export const getFilterSurveyLpResponse = (payload) => ({
  type: types.CHOOSE_LP_SURVEY_REPORT_FILTER_RES,
  payload,
});
export const getFilterSurveyLpClear = (payload) => ({
  type: types.CHOOSE_LP_SURVEY_REPORT_FILTER_RES_CLEAR,
  payload,
});
